interface FeeAndGstProps {
  fee_cost?: number | string;
}

const FeeAndGst = ({ fee_cost }: FeeAndGstProps) => {
  return <p className="polymer-fees-700">{typeof fee_cost === "number" ? `$${fee_cost?.toFixed(2)}` : fee_cost}</p>;
};

export default FeeAndGst;
